import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const BirthTimeDonut = () => {
    const { chartData } = useResultsChartsDataContext();

    return (
        <Donut
            title={'Horário de Nascimento'}
            subtitles={chartData?.birthTime?.map((item) => item.description)}
            chartData={chartData?.birthTime || []}
            colors={defaultColors.slice(0, chartData?.birthTime?.length) || []}
            height={400}
        />
    );
};
